import { mapGetters } from 'vuex'
import { TAGS_LIST_REQ, TAGS_CREATE_REQ, TAGS_UPDATE_REQ, TAGS_DELETE_REQ } from '@/store/modules/tags/tags.type'
import {
  UPDATE_AGENT_LOCATION_REQ
} from '@/store/modules/agents/agents.type'

export default {
  data() {
    return {
      openLocationPopUp: false,
      locationTag: {
        name: ''
      },
      locationTagRules: {
        name: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              value = value.trim().toLowerCase()
              if (value.length) {
                const locationTagsCopy = this.locationTags.map(tag => tag.name.toLowerCase())
                if (!locationTagsCopy.includes(value)) {
                  callback()
                } else {
                  callback(new Error('Name already exists'))
                }
              } else {
                callback(new Error("Name can't be blank"))
              }
            }
          }
        ]
      },
      activeLocationTagsCount: 0,
      hostLocationTagMap: {},
      removeTagBtnVisible: false,
      oldLocationTagName: ''
    }
  },
  computed: {
    ...mapGetters(['locationTags']),
    agentList () {
      return _.isUndefined(this.accountKeyActiveAgentList)
        ? this.activeAgentList
        : this.accountKeyActiveAgentList
    }
  },
  created() {
    this.$store.dispatch(TAGS_LIST_REQ)
  },
  methods: {
    openAddLocationDialog () {
      this.rowsSelected = _.cloneDeep(this.$refs.agentTable.rowsSelected)

      // set hostLocationTagMap with active tags
      this.rowsSelected.forEach(agent => {
        this.hostLocationTagMap[agent.customHostname] = agent.location
      })

      if (this.isFullIntersection(this.rowsSelected)) {
        // change status of all common tags to active
        this.locationTags.forEach(tag => {
          if (
            this.hostLocationTagMap[this.rowsSelected[0].customHostname] &&
            this.hostLocationTagMap[this.rowsSelected[0].customHostname].split(', ').includes(tag.name)
          ) {
            tag.active = true
            this.activeLocationTagsCount++
          }
        })
      }

      this.openLocationPopUp = true
    },
    isFullIntersection (selectedRows) {
      const commonLocationTags = this.hostLocationTagMap[selectedRows[0].customHostname]

      for (let row of selectedRows) {
        if (!_.isEqual(commonLocationTags, this.hostLocationTagMap[row.customHostname])) {
          return false
        }
      }
      return true
    },
    createLocationTag () {
      this.$refs['locationTagRef'].validate(valid => {
        if (valid) {
          const tag = {
            name: this.locationTag.name,
            active: false,
            editFlag: false
          }
          this.$store.dispatch(TAGS_CREATE_REQ, { type: 'location', tag: tag }).then(
            () => {
              this.locationTag.name = ''
            },
            err => {
              console.log(err.message)
            }
          )
        }
      })
    },
    handleLocationTagClick (idx) {
      this.locationTags[idx].active = !this.locationTags[idx].active
      this.locationTags[idx].active ? this.activeLocationTagsCount++ : this.activeLocationTagsCount--

      if (!this.activeLocationTagsCount) {
        this.removeTagBtnVisible = false;
      }
    },
    editTagName () {
      if (this.activeLocationTagsCount === 1) {
        const activeTag = this.locationTags.find(tag => tag.active)
        activeTag.editFlag = true

        this.$nextTick(_ => {
          this.$refs.locationTagInput[0].focus()
        })
      }
    },
    updateLocationsTags () {
      const activeTags = this.locationTags.filter(tag => tag.active).map(tag => tag.name)
      this.$store
        .dispatch(UPDATE_AGENT_LOCATION_REQ, {
          agents: _.map(this.rowsSelected, agent => {
            return { agentId: agent.agentId, location: activeTags.length ? activeTags.join(', ') : 'N/A' }
          })
        })
        .then(
          () => {
            this.$message({
              type: 'success',
              message: `Agent successfully tagged.`
            })
            this.rowsSelected.forEach(row => {
              const currentVm = this.agentList.models.find(agent => agent.customHostname === row.customHostname)
              if (currentVm) {
                // remove previous location tags from 'stringify' key
                currentVm.stringify = currentVm.stringify
                  .replace(`${this.hostLocationTagMap[currentVm.customHostname].toLowerCase()},`, "")
                  .replace(`${this.hostLocationTagMap[currentVm.customHostname].toLowerCase().replaceAll(', ', ',')}`, "")
                  .replace(`${this.hostLocationTagMap[currentVm.customHostname].toLowerCase().replaceAll(', ', ',')},`, "")
                // add updated location tags to'stringify' key
                currentVm.stringify += `${activeTags.join(',').toLowerCase()}`;

                this.hostLocationTagMap[currentVm.customHostname] = activeTags.join(', ')
                currentVm.location = activeTags.length ? activeTags.join(', ') : 'N/A';
              }
              // update the filtered data in iqcollections if a filter was selected
              if (!this.hostFiltersSelected.includes('all') || this.filtersSelected.length) {
                const currentFilteredVm = this.agentList.queriedData.find(
                  agent => agent.customHostname === row.customHostname
                )
                if (currentFilteredVm) {
                  currentFilteredVm.location = activeTags.join(', ')
                }
              }
            })

            this.resetLocationTagState()
            this.openLocationPopUp = false
          },
          errMsg => {
            // keep open & show error
            this.$message({
              type: 'error',
              message: errMsg || `Something went wrong.`
            })
            this.resetLocationTagState()
            this.openLocationPopUp = false
          }
        )
    },
    resetLocationTagState () {
      this.locationTags.forEach(tag => {
        tag.active = false
      })
      this.activeLocationTagsCount = 0
      this.hostLocationTagMap = {}
      this.$refs['locationTagRef'].resetFields()
      this.removeTagBtnVisible = false;
    },
    deleteLocationTags () {
      const deletedTags = this.locationTags.filter(tag => tag.active)

      this.$store.dispatch(TAGS_DELETE_REQ, { type: 'location', tags: deletedTags }).then(
        () => {
          // update value inside location key
          let agentsTagChanged = []
          // identify agents with tags and push to list for the POST call
          this.agentList.models.forEach(agent => {
            deletedTags.forEach(delTag => {
              if (agent.location.includes(delTag.name)) {
                let agentLocationArr = agent.location.split(', ')
                const delTagIdx = agentLocationArr.indexOf(delTag.name)
                if (delTagIdx !== -1) {
                  agentLocationArr.splice(delTagIdx, 1)
                }
                const agentLocationStr = agentLocationArr.join(', ')

                const agentsTagChangedObj = {
                  agentId: agent.agentId,
                  location: agentLocationStr
                }

                if (!agentsTagChangedObj.location) {
                  agentsTagChangedObj.location = 'N/A'
                }

                agentsTagChanged.push(agentsTagChangedObj)
              }
            })
          })
          if (agentsTagChanged.length) {
            this.$store
              .dispatch(UPDATE_AGENT_LOCATION_REQ, {
                agents: agentsTagChanged
              })
              .then(() => {
                // remove from hostLocationTagMap
                for (let key in this.hostLocationTagMap) {
                  this.hostLocationTagMap[key] = _.difference(this.hostLocationTagMap[key].split(', '), deletedTags)
                }

                // remove from all agents with tag
                this.agentList.models.forEach(agent => {
                  deletedTags.forEach(delTag => {
                    if (agent.location.includes(delTag.name)) {
                      let agentLocationArr = agent.location.split(', ')
                      const delTagIdx = agentLocationArr.indexOf(delTag.name)
                      if (delTagIdx !== -1) {
                        agentLocationArr.splice(delTagIdx, 1)
                      }
                      const agentLocationStr = agentLocationArr.join(', ')
                      
                      agent.location = agentLocationStr

                      if (!agent.location) {
                        agent.location = 'N/A'
                      }

                      // remove location tag from 'stringify' key
                      agent.stringify = agent.stringify
                        .replace(` ${delTag.name.toLowerCase()},`, "")
                        .replace(`${delTag.name.toLowerCase()},`, "")
                        .replace(delTag.name.toLowerCase(), "")
                    }
                  })
                })

                // update the filtered data in iqcollections if a filter was selected
                if (!this.hostFiltersSelected.includes('all') || this.filtersSelected.length) {
                  this.agentList.queriedData.forEach(agent => {
                    deletedTags.forEach(delTag => {
                      if (agent.location.includes(delTag.name)) {
                        let agentLocationArr = agent.location.split(', ')
                        const delTagIdx = agentLocationArr.indexOf(delTag.name)
                        if (delTagIdx !== -1) {
                          agentLocationArr.splice(delTagIdx, 1)
                        }
                        const agentLocationStr = agentLocationArr.join(', ')
                        
                        agent.location = agentLocationStr

                        if (!agent.location) {
                          agent.location = 'N/A'
                        }
                      }
                    })
                  })
                }
              })
          }
          this.openLocationPopUp = false
          this.removeTagBtnVisible = false
          this.resetLocationTagState()
          this.$message({
            type: 'success',
            message: `Successfully deleted.`
          })
        },
        err => {
          console.log(err.message)
        }
      )
    },
    onFocus (event) {
      this.oldLocationTagName = event.target.value
    },
    handleLocationTagNameChange (tag) {
      let updatedTag = { type: 'location', id: tag.id, oldtag: this.oldLocationTagName, tag: tag.name }
      this.$store.dispatch(TAGS_UPDATE_REQ, updatedTag).then(
        () => {
          // update value inside location key
          let agentsTagChanged = []
          this.agentList.models.forEach(agent => {
            if (agent.location.includes(updatedTag.oldtag)) {
              agentsTagChanged.push({
                agentId: agent.agentId,
                location: agent.location.replace(updatedTag.oldtag, updatedTag.tag)
              })
            }
          })
          if (agentsTagChanged.length) {
            this.$store
              .dispatch(UPDATE_AGENT_LOCATION_REQ, {
                agents: agentsTagChanged
              })
              .then(() => {
                // update value inside hostLocationTagMap
                for (const [key, val] of Object.entries(this.hostLocationTagMap)) {
                  const idx = val.includes(this.oldLocationTagName)
                  if (idx) {
                    this.hostLocationTagMap[key] = this.hostLocationTagMap[key].replace(
                      updatedTag.oldtag,
                      updatedTag.tag
                    )
                  }
                }

                // update from all agents with tag
                this.agentList.models.forEach(agent => {
                  if (agent.location.includes(updatedTag.oldtag) && agent.location !== updatedTag.tag) {
                    agent.location = agent.location.replace(updatedTag.oldtag, updatedTag.tag)
                    agent.stringify = agent.stringify.replace(
                      updatedTag.oldtag.toLowerCase(),
                      updatedTag.tag.toLowerCase()
                    )
                  }
                })

                // update the filtered data in iqcollections if a filter was selected
                if (!this.hostFiltersSelected.includes('all') || this.filtersSelected.length) {
                  this.agentList.queriedData.forEach(agent => {
                    if (agent.location.includes(updatedTag.oldtag)) {
                      agent.location = agent.location.replace(updatedTag.oldtag, updatedTag.tag)
                    }
                  })
                }

                tag.editFlag = false
              })
          }

          tag.editFlag = false
        },
        err => {
          console.log(err.message)
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/locationTagMixin.js